<template>
  <div
    v-if="!isBrowserChrome"
    class="chrome-warning"
  >
    <h3>
      Digital Foamboard works best on Google Chrome, you should totally switch
      👌
    </h3>
    <StitchDialog
      v-if="shouldShowWarning"
      visible
      center
      @close="shouldShowWarning = false"
    >
      <h2 slot="title">
        Ooops!
      </h2>
      <section class="chrome-warning__modal">
        <p>
          Digital Foamboard works best on Google Chrome, you should totally
          switch 👌
        </p>
        <p>
          We encourage you to get Chrome from <strong>Self Service</strong> and
          continue there. If you wish to continue with your current browser, be
          aware that some things might not work as expected.
        </p>
      </section>
    </StitchDialog>
  </div>
</template>

<script>
export default {
  name: 'ChromeWarning',

  data: () => ({
    shouldShowWarning: false
  }),

  computed: {
    /**
     * @returns {boolean}
     */
    isBrowserChrome () {
      return (
        /Chrome/.test(navigator.userAgent) &&
        /Google Inc/.test(navigator.vendor)
      )
    }
  },

  created () {
    this.shouldShowWarning = !this.isBrowserChrome
  }
}
</script>

<style lang="scss" scoped>
.chrome-warning {
  display: flex;
  align-items: center;
  justify-content: center;
  height: spacing(6);
  background-color: $orange;

  h3 {
    color: $white;
  }
}

.chrome-warning__modal {
  font-size: $font-size-larger;
  text-align: center;
  word-break: break-word;
}
</style>
